'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'box-check';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f467';
var svgPathData = 'M335.1 16c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.7 10.8 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.8 42.8C72.9 26 92.3 16 112.9 16l222.1 0zM16 148.5L16 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-267.5c0-1.5-.1-3-.2-4.5L16.2 144c-.1 1.5-.2 3-.2 4.5zm289.7 63.2c2.6-3.6 7.6-4.3 11.2-1.7 3.6 2.6 4.3 7.6 1.8 11.2L204.9 377.5c-1.4 1.9-3.6 3.1-5.9 3.3s-4.7-.7-6.3-2.4l-62.3-64.5c-3.1-3.2-3-8.2 .2-11.3s8.2-3 11.3 .2l55.7 57.6 108.1-148.7zM112.9 32c-15.5 0-30.1 7.5-39.1 20.1L24.9 120.6c-1.7 2.3-3.1 4.8-4.3 7.4l195.4 0 0-96-103.1 0zM232 128l195.4 0c-1.2-2.6-2.7-5-4.3-7.4L374.1 52.1c-9-12.6-23.6-20.1-39.1-20.1l-103.1 0 0 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;